import taskCenterPopup from './task-center/popup';

export default [...taskCenterPopup, {
  name: 'task-popup-common-zd',
  component: () => import(/* webpackChunkName: "task-popup-common-zd" */ './popup-common/popup-common.vue'),
}];
